import { useState } from "react";
import PropTypes from "prop-types";
import { Checkbox } from "@evertrue/et-components";
import ActiveJourneyPill from "components/elements/active-journey-pill";
import moment from "moment";

const OutreachDraftCard = ({ draft }) => {
  const { id, to, subject, created_at, body, cadence, email_template } = draft;
  const [selectedDraft, setSelectedDraft] = useState(false);

  const handleCheckboxChange = () => {
    setSelectedDraft((prevSelectedDraft) => !prevSelectedDraft);
  };

  const recipientName = to.length > 0 ? to[0].name : "";

  const getFormattedDate = (date) => {
    if (!date) return "";
    const isToday = moment(date).isSame(moment(), "day");

    if (isToday) {
      return moment(date).calendar(null, { sameDay: "[Today]" }) + ", " + moment(date).format("MMM DD, YYYY");
    }
    return moment(date).format("dddd, MMM DD, YYYY");
  };

  return (
    <div className="outreach-draft-card">
      <Checkbox
        className="outreach--checkbox-small"
        checked={selectedDraft}
        label="select"
        onChange={handleCheckboxChange}
      />
      <div>
        <div style={{ display: "flex" }} key={id}>
          <div className="outreach--draft-card--header">
            <p className="outreach-draft-recipient-name">{recipientName}</p>
            <strong>
              <p>{subject}</p>
            </strong>
          </div>
          <div className="outreach-draft-date-container">
            <p>{getFormattedDate(created_at)}</p>
          </div>
        </div>
        <div style={{ marginBottom: 0 }} className="outreach-draft-card-body">
          <p>{body}</p>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div className="draft-card-tab-group">
            <div className="draft-card-tab-group--item outreach-custom-active-pill">
              <ActiveJourneyPill activeCadence={cadence} />
            </div>
            <span className="draft-card-tab-group-border"> | </span>
            <div className="draft-card-tab-group--item outreach-custom-signal-video">
              <span className="tab-text">
                <i
                  role="img"
                  aria-label="icon: signal-video"
                  className="gt2-icon gt2-icon-signal-video base-nav-sub-item--icon gt-icon-fw draft-card-tab-group-icon-video"
                  alt="signal-video"
                  aria-hidden="true"
                ></i>
                &nbsp;View Signal Video
              </span>
            </div>
            <span className="draft-card-tab-group-border"> | </span>
            <div className="draft-card-tab-group--item">
              <span className="tab-text">
                <strong>Template:</strong>
              </span>{" "}
              <span className="tab-text">{email_template && email_template.name ? email_template.name : ""}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

OutreachDraftCard.propTypes = {
  draft: PropTypes.object.isRequired,
};

export default OutreachDraftCard;
